export default __webpack_public_path__ + "static/base-lite-4-0293fe25397f55cf1c233a1eabff95e7.jpg";